import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import TenantPicker from './TenantPicker';
import UpdateBanner from './UpdateBanner';

const pageTitles: Record<string, string> = {
  '/dashboard': 'Posture',
  '/overview': 'Overview',
  '/agents': 'Agents',
  '/audit': 'Audit',
  '/reports': 'Reports',
  '/releases': 'Releases',
  '/settings': 'Settings',
};

const Layout: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  const pageTitle = pageTitles[location.pathname]
    || (location.pathname.startsWith('/clients/') ? 'Client Posture' : undefined)
    || (location.pathname.startsWith('/agents/') ? 'Agent Detail' : undefined)
    || 'Dashboard';

  return (
    <div className="min-h-screen font-nippo">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area offset by sidebar width */}
      <div className="ml-64 flex flex-col min-h-screen">
        {/* Top header bar */}
        <header className="sticky top-0 z-20 h-16 bg-anchor-navy/75 backdrop-blur-sm border-b border-white/[0.06] flex items-center justify-between px-8">
          <h1 className="text-lg font-medium text-white">{pageTitle}</h1>
          <div className="flex items-center space-x-4">
            <TenantPicker />
            <span className="text-sm text-anchor-muted">
              {user?.name || user?.email}
            </span>
            <div className="h-8 w-8 bg-anchor-blue/20 rounded-full flex items-center justify-center">
              <span className="text-xs font-medium text-anchor-blue">
                {user?.name?.charAt(0) || user?.email?.charAt(0) || 'U'}
              </span>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-auto p-8">
          <Outlet />
        </main>
      </div>

      {/* Deploy-drift detector: prompts reload when a newer build is live */}
      <UpdateBanner />
    </div>
  );
};

export default Layout;
